module.exports = __webpack_public_path__ + "static/ig-34ba2154404205727b51c2ecbdb54df0.png";